/* globals FB: true app_config: true */
import { Promise } from 'es6-promise';

const loadFacebookScript = (d, s, id) => {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
        return;
    }
    const js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
};

const loadFacebook = appId => new Promise((resolve) => {
    console.log('LOAD');
    if (typeof FB !== 'undefined') {
        resolve(FB);
        return;
    }

    window.fbAsyncInit = () => {
        console.log('FACEBOOK LOADED');
        FB.init({
            appId: appId || app_config('facebook_app_id'),
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v2.10',
        });
        FB.AppEvents.logPageView();
        resolve(FB);
    };

    loadFacebookScript(document, 'script', 'facebook-jssdk');
});

export default loadFacebook;



// WEBPACK FOOTER //
// ./lib/loadFacebook.js